import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import IconComponent from '../../atoms/Icon'
import Html from '../../atoms/Html'
import ActionButton from '../../atoms/ActionButton'
import VideoPlayer from '../../atoms/Video'
import RecipeIngredients from '../RecipeIngredients'
import RecipeSteps from '../RecipeSteps'

export const Container = styled.article`
  padding: 3rem 1.5rem;
  gap: 4rem;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  @media ${mq(sizes.desktop)} {
    gap: 5rem;
  }
  @media ${mq(sizes.scoping)} {
    padding-inline: 3rem;
  }

  @media print {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    padding: 0;
    margin: -2rem 0 0 0;
  }
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;
  @media print {
    display: none;
  }
`
export const IntroText = styled(Html)`
  ${({ theme }) => theme.textStyles.textCaptions}
  @media ${mq(sizes.scoping)} {
    ${({ theme }) => theme.textStyles.textXLarge}
  }
  @media print {
    display: none;
  }
`
export const Actions = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 2rem;

  @media print {
    display: none;
  }
`
export const Button = styled(ActionButton)``

export const VideoTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH3}
  margin: 0;
  color: ${({ theme }) => theme.colors.arapawa};

  @media print {
    display: none;
  }
`

export const Video = styled(VideoPlayer)`
  @media print {
    display: none;
  }
`

export const Ingredients = styled(RecipeIngredients)`
  @media print {
    width: 35%;
  }
`

export const Steps = styled(RecipeSteps)`
  @media print {
    width: 65%;
  }
`

export const Text = styled(Html)`
  & > *,
  & > *:not(:last-child) {
    margin: 0;
    padding-block: 0;
  }
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    &:not(:first-child) {
      margin-top: 3rem;
    }
  }
  & p,
  & ol,
  & ul {
    &:not(:first-child) {
      margin-top: 2rem;
    }
    &:not(:last-child) {
      padding-bottom: 0;
    }
  }
  & p,
  & ul,
  & ol {
    color: ${({ theme }) => theme.colors.grey};
  }

  @media print {
    display: none;
  }
`

export const Icon = styled(IconComponent)`
  color: ${({ theme }) => theme.colors.atomicTangerine};
  width: 3.2rem;
  height: 3.2rem;
  flex-shrink: 0;
`
